import * as types from '../actiontypes';
import env from '../../util/env';
import utilityFunction from '../../util/utilityfunctions';

export function sendFilePathsToDocumentHelper(url, data, headers) {
	return {
		type: types.SEND_FILES_TO_DOCHELPER,
		meta: {
			api: {
				url: url,
				method: 'POST',
				data: data,
				headers: headers
			}
		}
	};
}

export function checkIfDocumentHelperOnline(url, data) {
	return {
		type: types.CHECK_IF_DOCHELPER_ONLINE,
		meta: {
			api: {
				url: url,
				method: 'GET',
				data: data
			}
		}
	};
}

/**
 * Upload a document using Document Helper
 * @param {String} entityType - Type of entity the document is uploaded from (see entityTypes in uiconstants for more details)
 * @param {String} parentName - ParentName. Usually 'evidences'.
 * @param {number} engagementId - Engagement id.
 * @param {number} workspaceId - Workspace id.
 * @param {String} [relatedEntityId] - Id of the entity the document will be related to (ie Task) (OPTIONAL)
 * @param {number} documentType - Document type (see DocumentType in uiconstants for more details)
 * @param {number} [documentExtensionId] - Document extension id. Used when uploading documents after the report release date (OPTIONAL)
 * @param {number} [documentChangeTypeId] - Reason for changing a document (see documentChangeTypes enumeration for more details) (OPTIONAL)
 * @param {String} [rationaleText] - Descriptive text for the documentChangeTypeId (OPTIONAL)
 * @param {boolean} [isUploadAfterRRD] - Boolean value indicating whether the document is being uploaded after the report date or not (OPTIONAL)
 * @param {number} taskTypeId - TaskTypeId (OPTIONAL)
 * @param {object} headers - Headers for the browse url sent to document helper.
 * @param {object} entityUid - EntityUid like bodyId. (OPTIONAL).
 * @param {boolean} requireValidations - requireValidations.
 * @param {number} sectionId - sectionId.
 * @param {Array<Guid>} relatedTasks - relatedTasks.
 * @param {boolean} [showCrashDocumentWarningMessage=false] - Boolean value indicating whether to show the crash document warning message or not (OPTIONAL).
 * @param {object} [signoffRequirements] - Signoff requirements (OPTIONAL).
 * @param {number} bodyTypeId - bodyTypeId.
 * @returns {object} - Upload document action.
 */
export function uploadDocumentWithDocumentHelper2(
	entityType,
	parentName,
	engagementId,
	workspaceId,
	relatedEntityId,
	documentType,
	documentExtensionId,
	documentChangeTypeId,
	rationaleText,
	isUploadAfterRRD,
	taskTypeId,
	headers,
	entityUid,
	requireValidations,
	sectionId,
	relatedTasks = [],
	showCrashDocumentWarningMessage = false,
	signoffRequirements = undefined,
	bodyTypeId
) {
	const docKey = `${parentName}_${entityUid}_${relatedEntityId}`;

	const query = {
		docUrl: env.getURL('Engg_Doc_Url'),
		engagementId: engagementId,
		resourceUri: env.getURL('Engg_AuthAudience_URL'),
		docTypeId: documentType,
		overwrite: false
	};

	const uploadUrl = `${env.getDocHelperConfig().docHelperApiUri}Document?${utilityFunction.createQueryString(query)}`;

	const browseUrl = `${env.getDocHelperConfig().docHelperApiUri}document/browse?${utilityFunction.createQueryString(
		query
	)}`;

	if (!headers) {
		headers = {
			connectionid: window.jQuery.connection.documentHubV2.connection.id
		};
	}

	const docHelperData = {
		documentType: documentType,
		documentExtensionId: documentExtensionId,
		documentChangeTypeId: documentChangeTypeId,
		rationaleText: rationaleText,
		isUploadAfterRRD: isUploadAfterRRD,
		isUserUpload: true,
		taskId: relatedEntityId, // To be removed...
		relatedEntityId: relatedEntityId,
		taskTypeId: taskTypeId,
		workspaceId: workspaceId,
		DocumentHubStatus: 'UPLOADSTART',
		inProgress: true,
		progressComplete: false,
		totalPercentage: 100,
		progressPercent: 0,
		sourceEngagementId: engagementId,
		engagementId: engagementId,
		dockey: docKey,
		entityUid: entityUid,
		requireValidations: requireValidations,
		parentName: parentName,
		sectionId: sectionId,
		relatedTasks,
		signoffRequirements,
		bodyTypeId
	};

	return {
		type: types.KRONOS_DOCHELPER_UPLOAD_DOCUMENT,
		parentName: parentName,
		meta: {
			api: {
				url: browseUrl,
				method: 'POST',
				data: [],
				headers: headers
			},
			docHelper: {
				url: uploadUrl,
				method: 'POST',
				headers: headers,
				payload: docHelperData
			}
		},
		docHelperConfig: env.getDocHelperConfig(),
		relatedTasks,
		showCrashDocumentWarningMessage
	};
}

//This action is dispatched on overwrite. This will not have api meta as it does not need to call the browse option
export function overWriteDocumentWithDocumentHelper(
	uploadurl,
	docHelperData,
	headers,
	data,
	relatedTasks = [],
	showCrashDocumentWarningMessage = false
) {
	return {
		type: types.KRONOS_DOCHELPER_UPLOAD_DOCUMENT,
		meta: {
			docHelper: {
				url: uploadurl,
				method: 'POST',
				headers: headers,
				payload: docHelperData,
				data: data
			}
		},
		overwrite: true,
		docHelperConfig: env.getDocHelperConfig(),
		relatedTasks,
		showCrashDocumentWarningMessage
	};
}

export function restoreDocumentVersion(engagementId, documentId, parentName) {
	const docUrl = `${env.getDocServiceUrl('documents.json')}/${documentId}/restoreversion`;

	return {
		type: types.RESTORE_DOCUMENT_VERSION,
		parentName: parentName,
		documentId: documentId,
		meta: {
			api: {
				url: docUrl,
				method: 'PATCH',
				headers: {
					engagementid: engagementId
				}
			}
		}
	};
}

export function downloadDocumentWithDocumentHelper(url, data, headers) {
	return {
		type: types.KRONOS_DOCHELPER_DOWNLOAD_DOCUMENT,
		meta: {
			docHelper: {
				url: url,
				method: 'GET',
				data: {},
				headers: headers,
				payload: data
			}
		},
		docHelperConfig: env.getDocHelperConfig()
	};
}
